/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import createElement from '../jsx/createElement';

const MenuContainer = function ({ assistiveText, children }) {
  return (
    <li className="wrapper chatMessage agent embeddedServiceLiveAgentStateChatItem embeddedServiceLiveAgentStateChatMenuMessage guuruContainer">
      <div className="chatContent">
        <div className="rich-menu">
          <div className="assistiveText">{assistiveText.text}</div>
          <ul className="rich-menu-items">
            {children}
          </ul>
        </div>
      </div>
      <div className="nameAndTimeContent" />
    </li>
  );
};

const MenuItem = function ({ item, clickHandler }) {
  return (
    <li>
      <button
        type="button"
        className="rich-menu-item embeddedServiceLiveAgentStateChatRichItem"
        onClick={() => clickHandler(item)}
      >
        {item.text}
      </button>
    </li>
  );
};

const ChatMenu = function ({ entries, clickHandler, assistiveText }) {
  return (
    <MenuContainer assistiveText={assistiveText}>
      {entries.map((entry) => (
        <MenuItem item={entry} clickHandler={clickHandler} />
      ))}
    </MenuContainer>
  );
};

export default ChatMenu;
